function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.loading--st0{fill:#231F20;enable-background:new    ;}\n\t.loading--st1{opacity:0.1;fill:#231F20;enable-background:new    ;}\n\t.loading--st2{opacity:8.000000e-02;fill:#231F20;enable-background:new    ;}\n\t.loading--st3{opacity:5.000000e-02;fill:#231F20;enable-background:new    ;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st0",
  d: "M24.8,0h7.1v14.2h-7.1V0z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: 0,
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st1",
  d: "M45.9,5.8l5,5l-10,10l-5-5L45.9,5.8z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.125s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st2",
  d: "M56.7,24.8v7.1H42.5v-7.1H56.7z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.25s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st3",
  d: "M50.9,45.9l-5,5l-10-10l5-5L50.9,45.9z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.375s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st3",
  d: "M31.9,56.7h-7.1V42.5h7.1V56.7z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.5s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st3",
  d: "M10.8,50.9l-5-5l10-10l5,5L10.8,50.9z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.675s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st2",
  d: "M0,31.9v-7.1h14.2v7.1H0z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.75s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "loading--st1",
  d: "M5.8,10.8l5-5l10,10l-5,5L5.8,10.8z"
}, React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "opacity",
  begin: "0.875s",
  calcMode: "linear",
  dur: "1s",
  fill: "remove",
  from: 1,
  repeatCount: "indefinite",
  restart: "always",
  to: 0.1
}));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "loading",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 56.7",
    style: {
      enableBackground: "new 0 0 56.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.2c6e8d1f.svg";
export { ForwardRef as ReactComponent };